import type { ReactNode } from "react";
import { NormalInfoWrapper } from "../../../tasks/styles";

type CalculationProps = {
  data: any;
}

interface Detail {
  label: string
  value: ReactNode
}

function getIndexOfLastRow(details: Detail[]) {
  let lastValidRow = -1;
  let secondLastValidRow = -1;
  let validCount = 0;

  for (let i = 0; i < details.length; i++) {
    if (details[i].value != null) {
      secondLastValidRow = lastValidRow;
      lastValidRow = i;
      validCount++;
    }
  }

  return validCount % 2 === 0
    ? [secondLastValidRow, lastValidRow]
    : [lastValidRow];
}

export const CalculationRow = ({ data }: CalculationProps) => {

  const psd2Variables = data?.integrations?.statistica?.psd2?.variables;

  const calculationDetails: Detail[] = [
    { label: "Expert score", value: psd2Variables?.Expert_score_new },
    { label: "PD", value: psd2Variables?.PD },
    { label: "ROE", value: psd2Variables?.ROE },
    { label: "Max loan amt PD", value: psd2Variables?.Max_Loan_PD },
    { label: "Max loan amt from NDI", value: psd2Variables?.MaxLoanAmt },
    { label: "Upsell amount", value: psd2Variables?.Upsell_Amount },
  ]

  const lastIndexes = getIndexOfLastRow(calculationDetails)

  const isEmpty = calculationDetails.every(
    (detail) => detail.value === null || detail.value === undefined,
  )
  if (isEmpty) return null

  return (
    <>
      <NormalInfoWrapper $header>Calculation</NormalInfoWrapper>
      {calculationDetails.map((detail, index) => {
        if (detail.value === null || detail.value === undefined) return

        return (
          <NormalInfoWrapper
            key={`calculation-${index}-${detail.label}`}
            $isLast={lastIndexes.includes(index)}
          >
            <div>{detail.label}</div>
            <div>{detail.value}</div>
          </NormalInfoWrapper>
        )
      })}
    </>
  )
}
